import { render, staticRenderFns } from "./param-group.component.vue?vue&type=template&id=57b0e6ac"
import script from "./param-group.component.vue?vue&type=script&lang=js"
export * from "./param-group.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports